import createMapEditorPlayer from '../player/createMapEditorPlayer'
import { createNewRNGConfig } from '../rng'
import createDefaultStateConfig from './create_default_state_config'
import createDefaultStateMap from './create_default_state_map'
import { type State } from './State.type'
import { StateType } from './state_type.enum'

export function createDefaultNewGameState(width: number, height: number): State {
  const rng = createNewRNGConfig()

  const m: State = {
    // id: randomUid(),
    round: 1,
    online: null,
    type: StateType.Map,
    config: createDefaultStateConfig(),
    map: createDefaultStateMap(),
    width,
    height,
    ents: [],
    players: [],
    turnPlayerId: null,
    rng,
  }

  m.players.push(createMapEditorPlayer(m, rng))
  m.players.push(createMapEditorPlayer(m, rng))

  return m
}
